module.exports = __webpack_public_path__ + "static/knecht-old-ade7e4350b205f3fa38ad654c5672616.svg";